module.exports = __webpack_public_path__ + "static/img/trumpet.828c07b2.svg";